import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { cloneDeep } from "lodash";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";

export interface IUpdateHeaderActionPayload {
  prevHeader: IWebsiteBuilderHeader;
  nextHeader: IWebsiteBuilderHeader;
}

export interface IUpdateHeaderAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.UPDATE_HEADER;
  payload: IUpdateHeaderActionPayload;
}

export function getUpdateHeaderInverseAction(action: IUpdateHeaderAction): IUpdateHeaderAction {
  const { nextHeader, prevHeader } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.UPDATE_HEADER,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: action.scrollNodeId,
    payload: {
      prevHeader: cloneDeep(nextHeader),
      nextHeader: cloneDeep(prevHeader),
    },
  };
}

export function applyUpdateHeaderChange(
  _header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IUpdateHeaderAction,
): IWebsiteBuilderHistorySnapshot {
  return {
    header: cloneDeep(action.payload.nextHeader),
    root,
    footer,
  };
}
